import { Transform } from "class-transformer";
import { Allow, IsBoolean, IsEnum, IsOptional, IsString, IsUUID } from "class-validator";
import type { Moment } from "moment";

import { transformMoment } from "../helpers/transforms";
import { IsMoment } from "../helpers/decorators";

import { User } from "./user";

export const notificationTypes = ["info", "message", "warning"];
export type NotificationType = (typeof notificationTypes)[number];

export class UserNotification {
  @Allow()
  user: User;

  @IsUUID()
  userNotificationId: string;
  @IsOptional()
  @IsUUID()
  notificationContextId?: string;
  @IsString()
  message: string;
  @IsEnum(notificationTypes)
  type: NotificationType;
  @IsOptional()
  @IsString()
  action: string;
  @IsBoolean()
  acknowledged: boolean;
  @Transform(transformMoment)
  @IsMoment()
  createdAt: Moment;
  @Transform(transformMoment)
  @IsMoment()
  updatedAt: Moment;
}
